import { render, staticRenderFns } from "./camPower.vue?vue&type=template&id=2b2c6f0a&"
import script from "./camPower.vue?vue&type=script&lang=js&"
export * from "./camPower.vue?vue&type=script&lang=js&"
import style0 from "./camPower.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports